import { getCatalog, saveCatalog } from './catalog';
import { getAgents, mergeAgents } from './agents';
import { guardExternal } from './policy';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/catalog/share`;
export const QR_PREFIX = 'GISSCAT:';

export async function shareCatalog() {
  guardExternal();
  const { sector, items } = getCatalog();
  const res = await fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ sector, items, agents: getAgents() }) });
  if (!res.ok) throw new Error('share');
  return res.json();
}

export const parseShareCode = (txt) => {
  const s = String(txt || '').trim().toUpperCase().replace(QR_PREFIX, '');
  return /^[A-Z0-9]{6}$/.test(s) ? s : null;
};

export async function fetchShared(code) {
  guardExternal();
  const res = await fetch(`${API}/${code}`);
  if (res.status === 404) throw new Error('notfound');
  if (!res.ok) throw new Error('net');
  return res.json();
}

const clean = (x) => {
  const o = { ...x };
  if (o.color != null && !/^#[0-9a-f]{3,8}$/i.test(String(o.color))) delete o.color;
  ['type', 'kind', 'cat', 'id'].forEach((k) => { if (o[k] != null) o[k] = String(o[k]).replace(/[^\w-]/g, ''); });
  return o;
};

export function applyShared(raw, merge) {
  if (raw.agents?.length) mergeAgents(raw.agents, !merge);
  const data = { ...raw, items: (raw.items || []).map(clean) };
  if (!merge) return saveCatalog({ sector: data.sector || 'water', items: data.items });
  const cur = getCatalog();
  const inc = Object.fromEntries(data.items.map((x) => [x.id, x]));
  const items = [...cur.items.map((x) => inc[x.id] || x), ...data.items.filter((x) => !cur.items.some((y) => y.id === x.id))];
  return saveCatalog({ ...cur, items });
}
